import { render, staticRenderFns } from "./CustomsDeclareList.vue?vue&type=template&id=d1731838&"
import script from "./CustomsDeclareList.vue?vue&type=script&lang=js&"
export * from "./CustomsDeclareList.vue?vue&type=script&lang=js&"
import style0 from "./CustomsDeclareList.vue?vue&type=style&index=0&id=d1731838&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports